<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'received-report.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'received-report.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'received-report.payment' | transloco }}</small>
              <hx-enum-select [(ngModel)]="params.paymentTypes" enumName="PaymentType" [enumType]="PaymentType" [multiple]="true"></hx-enum-select>
            </div>

            <div class="filter">
              <small>{{ 'received-report.categories' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryIds" [multiple]="true" [brandId]="brandId"></hx-product-category-select>
            </div>

            <div class="filter">
              <small>{{ 'received-report.limit' | transloco }}</small>
              <ng-select class="limit" [items]="limits" bindLabel="id" bindValue="id" placeholder=""
                         [(ngModel)]="params.limit"></ng-select>
            </div>
          </div>

          <button type="button" *ngIf="params.storeIds.length === 1" (click)="generate()" class="btn btn-outline-success m--margin-top-15 m--margin-right-10"
                  [disabled]="isLoading.generate" [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.generate}">
            {{ 'download' | transloco }}
          </button>

          <button type="button" (click)="applyFilters()" class="btn btn-outline-primary m--margin-top-15"
                  [disabled]="isLoading.list" [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.list}">
            {{ 'search' | transloco }}
          </button>

          <hr>

          <div class="org-title" *ngIf="params.storeIds.length === 1">
            {{ 'received-report.organization' | transloco }}: {{ organization?.title | uiLabel }}
          </div>
          <div class="store-title" *ngIf="params.storeIds.length === 1">
            {{ 'received-report.shop' | transloco }}: {{ store?.title | uiLabel }}
          </div>
          <br/>
          <br/>
          <div class="report-title" *ngIf="params.storeIds.length === 1">
            {{ 'reports.shipment-received' | transloco }} {{ 'received-report.behind' | transloco }} {{ params.date?.from | date:'dd.MM.yyyy' }} - {{ params.date?.to | date:'dd.MM.yyyy' }}
          </div>
          <br/>
          <div *ngIf="productShipmentList.length && !isLoading.list" class="block-table-scroll">
            <table>
              <thead>
              <tr class="fixed-head-oline">
                <th class="text-center fixed-head-one" rowspan="2">{{ 'received-report.table.head.name' | transloco }}</th>
                <th class="text-center fixed-head-two" rowspan="2">{{ 'received-report.table.head.nomenclature' | transloco }} <br>{{ 'received-report.table.head.code' | transloco }}</th>
                <th class="text-center fixed-head-three" rowspan="2">{{ 'received-report.table.head.quantity' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'received-report.table.head.unit' | transloco }} <br>{{ 'received-report.table.head.change' | transloco }}</th>
                <th class="text-center fixed-head-fourth" rowspan="2">{{ 'received-report.table.head.store' | transloco }}</th>
                <th *ngFor="let cmn of columns" class="text-center" colspan="3">
                  {{'paymentType.' + cmn | transloco}}
                </th>
                <th class="text-center" rowspan="2">{{ 'received-report.table.head.cost' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'received-report.table.head.total' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'received-report.table.head.currency' | transloco }}</th>
              </tr>
              <tr class="fixed-head-tline">
                <ng-container *ngFor="let cmn of columns">
                  <th>{{ 'received-report.table.head.amount' | transloco }}</th>
                  <th>{{ 'received-report.table.head.sum' | transloco }}</th>
                  <th>{{ 'received-report.table.head.discount' | transloco }}</th>
                </ng-container>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let productSale of productShipmentList">
                <tr>
                  <td class="tbody-fixed-one">{{ productSale.productTitle | uiLabel }}</td>
                  <td class="tbody-fixed-two">{{ productSale.productExt1cCode }}</td>
                  <td class="tbody-fixed-three">{{ productSale.totalAmount }}</td>
                  <td>{{ productSale.unitOfMeasureTitle | uiLabel }}</td>
                  <td class="tbody-fixed-fourth">{{ storeMap.get(productSale.storeId)?.title | uiLabel }}</td>
                  <ng-container *ngFor="let pt of productSale.payments">
                    <td>{{ pt.amount }}</td>
                    <td>{{ pt.value }}</td>
                    <td>{{ pt.discount }}</td>
                  </ng-container>
                  <td>{{ productSale.costPrice }}</td>
                  <td>{{ productSale.totalValue }}</td>
                  <td>{{ currencySymbol }}</td>
                </tr>
              </ng-container>
              </tbody>
              <tfoot class="table-footer-fixed">
              <tr>
                <th>{{ 'received-report.table.head.total' | transloco }}</th>
                <th></th>
                <th>{{ reportTotalInfo.amountTotal }}</th>
                <th></th>
                <th></th>
                <ng-container *ngFor="let pt of reportTotalInfo.payments">
                  <th>{{ pt.amount }}</th>
                  <th colspan="2" style="text-align: right">{{ pt.value }}</th>
                </ng-container>
                <th>{{ reportTotalInfo.totalCostPrice }}</th>
                <th>{{ reportTotalInfo.total }}</th>
                <th></th>
              </tr>
              </tfoot>
            </table>
          </div>
          <hx-loader [length]="productShipmentList.length" [isLoading]="isLoading.list"></hx-loader>
          <br/>
          <br/>

          <div class="m--align-center" *ngIf="productShipmentList.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
